module.exports = __webpack_public_path__ + "img/woman-head-back.d984ba48.png";